import { render, staticRenderFns } from "./ProvidedServices.vue?vue&type=template&id=7402047f&scoped=true"
import script from "./ProvidedServices.vue?vue&type=script&lang=js"
export * from "./ProvidedServices.vue?vue&type=script&lang=js"
import style0 from "./ProvidedServices.vue?vue&type=style&index=0&id=7402047f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7402047f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7402047f')) {
      api.createRecord('7402047f', component.options)
    } else {
      api.reload('7402047f', component.options)
    }
    module.hot.accept("./ProvidedServices.vue?vue&type=template&id=7402047f&scoped=true", function () {
      api.rerender('7402047f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/ProvidedServices.vue"
export default component.exports